import * as React from 'react';
import { Route } from 'react-router';
import CoachingContainer from 'coaching/CoachingContainer';
// @ts-ignore
import RequireUser from 'lib/RequireUser';

export default (
  <Route path="/coaching/get_started" component={CoachingContainer} onEnter={RequireUser} />
);
